import React, { memo } from "react";

const EditIcon: React.FC = memo(() => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7317 5.07978L11.3951 1.80572L12.2341 0.967722C12.5463 0.655908 12.9205 0.5 13.3565 0.5C13.792 0.5 14.1593 0.655908 14.4585 0.967722L15.5512 2.07856C15.8504 2.37739 16 2.74117 16 3.16991C16 3.59866 15.8504 3.96244 15.5512 4.26127L14.7317 5.07978ZM1.56098 16.5C1.13171 16.5 0.764097 16.3472 0.458146 16.0416C0.152715 15.7366 0 15.3697 0 14.9409V4.02741C0 3.59866 0.152715 3.2315 0.458146 2.92592C0.764097 2.62086 1.13171 2.46833 1.56098 2.46833H8.52683L3.80488 7.18453C3.58374 7.4054 3.41463 7.65875 3.29756 7.94458C3.18049 8.23041 3.12195 8.52923 3.12195 8.84105V11.8228C3.12195 12.2515 3.27493 12.6184 3.58088 12.9235C3.88631 13.2291 4.25366 13.3819 4.68293 13.3819H7.66829C7.98049 13.3819 8.27967 13.3234 8.56585 13.2065C8.85203 13.0895 9.10569 12.9206 9.32683 12.6998L14.0488 7.96407V14.9409C14.0488 15.3697 13.8961 15.7366 13.5906 16.0416C13.2847 16.3472 12.9171 16.5 12.4878 16.5H1.56098ZM5.46341 11.8228C5.24228 11.8228 5.05704 11.7482 4.90771 11.599C4.75785 11.4494 4.68293 11.2641 4.68293 11.0432V9.15286C4.68293 8.94498 4.72195 8.74672 4.8 8.55807C4.87805 8.36995 4.98862 8.20442 5.13171 8.06151L10.2829 2.91657L13.6195 6.19062L8.44878 11.3551C8.30569 11.498 8.13997 11.6118 7.95161 11.6965C7.76273 11.7807 7.56423 11.8228 7.3561 11.8228H5.46341Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { EditIcon };
